// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { NetworkSource } from "@lib/messaging/NetworkSource";

/**
 * Describes a messages as it is sent over the messaging API.
 * Similar to an IP packet, as it contains source/destination as well as the overlying protocol.
 */
export type RawMessage = {
  destination: NetworkSource;
  source: NetworkSource;
  messageFormat: string;
  messageObject: object;
};